module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.openEditModel('ADD')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menuConfig.menu.addMenu')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.refreshMenu
    }
  }, [_vm._v(_vm._s(_vm.$t('menuConfig.menu.refreshMenu')))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-tree', {
    attrs: {
      "data": _vm.resultData,
      "props": _vm.defaultProps,
      "node-key": "id",
      "expand-on-click-node": false,
      "render-content": _vm.renderContent
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.modelTitle,
      "visible": _vm.editMenuModelVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.editMenuModelVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "rules": _vm.editRules
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.initListData
    }
  }, [_vm._v("列表")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    }
  }), _vm._v(" "), _vm._l((_vm.menuNameLangA), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": item,
        "label-width": "120",
        "prop": "item"
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off"
      },
      model: {
        value: (_vm.menuNameLangO[item]),
        callback: function($$v) {
          _vm.$set(_vm.menuNameLangO, item, $$v)
        },
        expression: "menuNameLangO[item]"
      }
    })], 1)
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "url",
      "label-width": "120",
      "prop": "url"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editForm.url),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "url", $$v)
      },
      expression: "editForm.url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "uri",
      "label-width": "120",
      "prop": "uri"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editForm.uri),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "uri", $$v)
      },
      expression: "editForm.uri"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "darkgrey"
    }
  }, [_vm._v("完整路径: @/components/xxx.vue")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "meta",
      "label-width": "120",
      "prop": "meta"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editForm.meta),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "meta", $$v)
      },
      expression: "editForm.meta"
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editForm.subId),
      expression: "editForm.subId"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.editForm.subId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editForm, "subId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('menuConfig.menu.orderBy'),
      "label-width": "120",
      "prop": "menuSortNo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.editForm.menuSortNo),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "menuSortNo", $$v)
      },
      expression: "editForm.menuSortNo"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editMenuModelVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitEditForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.ok')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('menu.menuEdit'),
      "visible": _vm.editMenuPosition
    },
    on: {
      "update:visible": function($event) {
        _vm.editMenuPosition = $event
      }
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 9999
    },
    model: {
      value: (_vm.menuIndex),
      callback: function($$v) {
        _vm.menuIndex = $$v
      },
      expression: "menuIndex"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editMenuPosition = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleChange()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.ok')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.editMenuNameAndUrl
    },
    on: {
      "update:visible": function($event) {
        _vm.editMenuNameAndUrl = $event
      }
    }
  }, [_c('el-form', {
    ref: "submitForm",
    staticClass: "gForm",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label-position": "right",
      "label-width": "12.5%",
      "model": _vm.submitForm,
      "rules": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_name'),
      "prop": "roleName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.submitForm.name),
      callback: function($$v) {
        _vm.$set(_vm.submitForm, "name", $$v)
      },
      expression: "submitForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "URL",
      "prop": "memo"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.submitForm.url),
      callback: function($$v) {
        _vm.$set(_vm.submitForm, "url", $$v)
      },
      expression: "submitForm.url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Icon",
      "prop": "memo"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.submitForm.icon),
      callback: function($$v) {
        _vm.$set(_vm.submitForm, "icon", $$v)
      },
      expression: "submitForm.icon"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editMenuNameAndUrl = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitMenuEdit()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.ok')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d4bceca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/menu-list.vue
// module id = 988
// module chunks = 0